/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JackpotStatus } from './JackpotStatus';
import {
    JackpotStatusFromJSON,
    JackpotStatusFromJSONTyped,
    JackpotStatusToJSON,
} from './JackpotStatus';
import type { FastPlayJackpot } from './FastPlayJackpot';
import {
    FastPlayJackpotFromJSON,
    FastPlayJackpotFromJSONTyped,
    FastPlayJackpotToJSON,
} from './FastPlayJackpot';

/**
 * 
 * @export
 * @interface FastPlayJackpotInfo
 */
export interface FastPlayJackpotInfo {
    /**
     * 
     * @type {FastPlayJackpot}
     * @memberof FastPlayJackpotInfo
     */
    jackpot?: FastPlayJackpot;
    /**
     * 
     * @type {JackpotStatus}
     * @memberof FastPlayJackpotInfo
     */
    jackpotStatus: JackpotStatus;
}



/**
 * Check if a given object implements the FastPlayJackpotInfo interface.
 */
export function instanceOfFastPlayJackpotInfo(value: object): value is FastPlayJackpotInfo {
    if (!('jackpotStatus' in value) || value['jackpotStatus'] === undefined) return false;
    return true;
}

export function FastPlayJackpotInfoFromJSON(json: any): FastPlayJackpotInfo {
    return FastPlayJackpotInfoFromJSONTyped(json, false);
}

export function FastPlayJackpotInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FastPlayJackpotInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'jackpot': json['jackpot'] == null ? undefined : FastPlayJackpotFromJSON(json['jackpot']),
        'jackpotStatus': JackpotStatusFromJSON(json['jackpotStatus']),
    };
}

export function FastPlayJackpotInfoToJSON(value?: FastPlayJackpotInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jackpot': FastPlayJackpotToJSON(value['jackpot']),
        'jackpotStatus': JackpotStatusToJSON(value['jackpotStatus']),
    };
}

